module.exports = __webpack_public_path__ + "images/content-section/section-content-units.svg";